import { render, staticRenderFns } from "./CusAddress.vue?vue&type=template&id=22602172&scoped=true&"
import script from "./CusAddress.vue?vue&type=script&setup=true&lang=js&"
export * from "./CusAddress.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22602172",
  null
  
)

export default component.exports